import React from 'react';
import styles from 'components/layout_and_quote_builder/_style.module.scss';

// The demo template's real dieline (Drawing 45291, a Tuck Top Auto Bottom
// carton) as it looks from above on the die-cutting line: a die-cut sheet
// with a solid cut outline and solid fold / crease lines. The geometry is
// the same one ImageUpload::Svg renders for the demo drawing, reduced to two
// merged paths and recoloured black & white.
const DIELINE_VIEW_BOX = '-31.8 -232.8 350 287.5';
const DIELINE_CUT_PATH = 'M299.5 0L299.5 -150M0 0L-13 -13M-13 -13L-13 -146.5M-13 -146.5L0 -150M94.7 4.6L98 7.9M98 7.9L98 36M98 36L86 36M86 36L75 25M0 0L3.1 36M3.1 36L41.5 36M41.5 36L50 27.5M50 27.5L50 25M50 25L75 25M244.7 4.6L248 7.9M248 7.9L248 36M248 36L236 36M236 36L225 25M150 0L153.1 36M153.1 36L191.5 36M191.5 36L200 27.5M200 27.5L200 25M200 25L225 25M100 0L109.1 25M109.1 25L125 25M125 25L150 0M250 0L259.1 25M259.1 25L275 25M275 25L299.5 0M99.4 -0.1L94.7 4.6M249.4 -0.1L244.7 4.6M239.9 -214L160.1 -214M100 -150L0 -150M250 -150L250 -200M250 -200L241 -200M241 -200L241 -199M159 -199L159 -200M159 -200L150 -200M150 -200L150 -150M100 -150L100.5 -150M100.5 -150L100.5 -157M100.5 -157L103.5 -160M103.5 -160L109.4 -182M299.5 -150L299.5 -157M299.5 -157L296.5 -160M296.5 -160L290.6 -182M109.4 -182L150 -182M250 -182L290.6 -182M 100 0 A 0.4 0.4 0 0 0 99.4 -0.1M 250 0 A 0.4 0.4 0 0 0 249.4 -0.1M 249.5 -200 A 15 15 0 0 0 239.9 -214M 160.1 -214 A 15 15 0 0 0 150.5 -200';
const DIELINE_CREASE_PATH = 'M100 0L100 -150M150 -150L150 0M250 0L250 -150M0 -150L0 0M75 25L95.1 4.9M0 0L99.3 0M225 25L245.1 4.9M150 0L249.3 0M150 0L100 0M299.5 0L250 0M241 -199L159 -199M150 -150.5L250 -150.5M150 -150L100.5 -150M250 -150L299.5 -150';

const DielineSheet = () => (
  <div className={styles.dieline}>
    <svg className={styles.dielineSvg} viewBox={DIELINE_VIEW_BOX} aria-hidden="true">
      <rect
        className={styles.dielineSheet}
        x="-31.8"
        y="-232.8"
        width="350"
        height="287.5"
        rx="8"
      />
      <path className={styles.dielineCrease} d={DIELINE_CREASE_PATH} />
      <path className={styles.dielineCut} d={DIELINE_CUT_PATH} />
    </svg>
  </div>
);

const LoadingOverlay = ({ message }) => {
  const displayMessage = message || 'Loading';

  return (
    <div className={styles.progressOverlay}>
      <div className={styles.progressCard}>
        <div className={styles.progressTitle}>
          {displayMessage}
        </div>

        <div className={styles.loadingSpinnerContainer}>
          {/* Manufacturing line seen from above: flat dielines travelling along the belt */}
          <div className={styles.conveyor} role="img" aria-label={displayMessage}>
            <DielineSheet />
            <DielineSheet />
            <DielineSheet />
            <div className={`${styles.conveyorRail} ${styles.conveyorRailTop}`} />
            <div className={`${styles.conveyorRail} ${styles.conveyorRailBottom}`} />
          </div>
        </div>

        <div className={styles.loadingHint}>
          {t('quote_builder.loading_hint')}
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay;
